var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-table" },
    [
      _c("div", { staticClass: "box" }, [
        _c("div", [
          _vm._v(" 关联的物料使用申请"),
          !_vm.disabled
            ? _c("i", {
                staticClass: "el-icon-plus icon-style-jia",
                on: { click: _vm.addTable },
              })
            : _vm._e(),
        ]),
        _c("div", { staticClass: "text" }, [
          _vm._v(_vm._s((_vm.subjectList[0] || {}).code || "")),
        ]),
      ]),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }